import * as React from 'react';

const SvgGroupPendingIntro = (props) => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={23} cy={23} r={23} fill="#4397F7" />
    <circle cx={23} cy={23} r={12} fill="#4397F7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 17.6666C21 18.403 20.403 18.9999 19.6667 18.9999C18.9303 18.9999 18.3333 18.403 18.3333 17.6666C18.3333 16.9302 18.9303 16.3333 19.6667 16.3333C20.403 16.3333 21 16.9302 21 17.6666ZM19.6667 18.9999C18.5621 18.9999 17.6667 19.5969 17.6667 20.3333C17.6667 21.0696 18.5621 21.6666 19.6667 21.6666C20.7712 21.6666 21.6667 21.0696 21.6667 20.3333C21.6667 19.5969 20.7712 18.9999 19.6667 18.9999ZM27 26.9999C27.7364 26.9999 28.3333 26.403 28.3333 25.6666C28.3333 24.9302 27.7364 24.3333 27 24.3333C26.2636 24.3333 25.6667 24.9302 25.6667 25.6666C25.6667 26.403 26.2636 26.9999 27 26.9999ZM27 26.9999C28.1046 26.9999 29 27.5969 29 28.3333C29 29.0696 28.1046 29.6666 27 29.6666C25.8954 29.6666 25 29.0696 25 28.3333C25 27.5969 25.8954 26.9999 27 26.9999ZM22.5 16.9999C22.5 16.7238 22.7239 16.4999 23 16.4999C26.5899 16.4999 29.5 19.4101 29.5 22.9999C29.5 23.2761 29.2761 23.4999 29 23.4999C28.7239 23.4999 28.5 23.2761 28.5 22.9999C28.5 19.9624 26.0376 17.4999 23 17.4999C22.7239 17.4999 22.5 17.2761 22.5 16.9999ZM17 22.4999C17.2761 22.4999 17.5 22.7238 17.5 22.9999C17.5 26.0375 19.9624 28.4999 23 28.4999C23.2761 28.4999 23.5 28.7238 23.5 28.9999C23.5 29.2761 23.2761 29.4999 23 29.4999C19.4101 29.4999 16.5 26.5898 16.5 22.9999C16.5 22.7238 16.7239 22.4999 17 22.4999Z"
      fill="white"
    />
  </svg>
);

export default SvgGroupPendingIntro;
